import React, { forwardRef } from 'react';

import { Checkbox } from 'primereact/checkbox';
import { classNames } from 'primereact/utils';
import { GroupedAddon } from './GroupedAddon';

export const GroupTitledCheckRadio = forwardRef((props, ref) => {
  const {
    name,
    title = '',
    value,
    defaultValue = '',
    items = [],
    onChange,
    error,
    disabled = false,
    readOnly = false,
    classNameProps,
    variant,
  } = props;

  function handleCheckboxChange(checkedValue) {
    if (value === checkedValue) {
      onChange(defaultValue);
    } else {
      onChange(checkedValue);
    }
  }

  return (
    <div className={classNames('p-inputgroup h-full', { 'p-error': error })}>
      <GroupedAddon
        title={title}
        variant={variant}
        classNameProps={classNameProps}
      />
      <div
        className={classNames(
          'cm-grouped-body p-inputgroup-addon bg-transparent w-full h-full',
          { 'bg-gray-100': disabled }
        )}
      >
        {items.map((item, idx) => (
          <div key={`${name}_${idx}`}>
            <div className="flex flex-auto align-items-center justify-content-start gap-1">
              <Checkbox
                inputRef={ref}
                inputId={`trb_${props.id || name}_${idx}`}
                name={name}
                value={item.value}
                onChange={() => handleCheckboxChange(item.value)}
                checked={value === item.value}
                disabled={disabled}
                readOnly={readOnly}
              />
              <label htmlFor={`trb_${props.id || name}_${idx}`}>
                {item.label}
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});

GroupTitledCheckRadio.displayName = 'GroupTitledCheckRadio';
